import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Truck, Settings, Wrench, ChevronRight } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mak-group-hub/artifacts/bgmgmbjd_image.png";

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img src={LOGO_URL} alt="MAK Group Logo" className="h-20 w-auto mb-6" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              A leading provider of heavy equipment, transport solutions, and machinery spare parts across the UAE and region.
            </p>
          </div>

          {/* Our Companies */}
          <div>
            <h4 className="text-lg font-bold mb-6">Our Companies</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/companies/mak-spare-parts" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-mak-spare">
                  <Wrench size={16} className="text-[#F5B800]" />
                  MAK Heavy Equipment Spare Parts
                </Link>
              </li>
              <li>
                <Link to="/companies/hayalogix" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-hayalogix">
                  <Truck size={16} className="text-[#F5B800]" />
                  HayalogiX Transport & Equipment
                </Link>
              </li>
              <li>
                <Link to="/companies/bright-perfect" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-bright-perfect">
                  <Settings size={16} className="text-[#F5B800]" />
                  Bright Perfect Heavy Equipment
                </Link>
              </li>
              <li>
                <Link to="/companies/hammer-mount" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-hammer-mount">
                  <Wrench size={16} className="text-[#F5B800]" />
                  HAMMER MOUNT Contracting
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-home">
                  <ChevronRight size={16} />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-about">
                  <ChevronRight size={16} />
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/companies" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-companies">
                  <ChevronRight size={16} />
                  Our Companies
                </Link>
              </li>
              <li>
                <Link to="/products" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-products">
                  <ChevronRight size={16} />
                  MAK Catalogs
                </Link>
              </li>
              <li>
                <Link to="/online-store" className="flex items-center gap-2 text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-mak-products">
                  <ChevronRight size={16} />
                  MAK Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#F5B800] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  <strong className="text-gray-300">Head Office:</strong><br />
                  10 Royal Auto Center, Naif, Deira, Dubai
                </span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#F5B800] mt-1 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  <strong className="text-gray-300">Branch Office:</strong><br />
                  Office 25, Floor 11, Mayzad Mall Tower 2 - MBZ, Abu Dhabi
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#F5B800] flex-shrink-0" />
                <a href="tel:+971563419000" className="text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-phone">
                  +971 56 341 9000
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#F5B800] flex-shrink-0" />
                <a href="mailto:info@makemirates.com" className="text-gray-400 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-email">
                  info@makemirates.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              &copy; {new Date().getFullYear()} MAK Group of Company. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-500 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-privacy">Privacy Policy</a>
              <a href="#" className="text-gray-500 hover:text-[#F5B800] transition-colors text-sm" data-testid="footer-terms">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
